import * as React from "react";
import styles from "./EnergyLabel.module.scss";
import {useState} from "react";
import Modal from "../lib/ModalWindow/Modal";

type EnergyLabelProps = {
  energyClass: string;
  media?: string;
  className?: string;
  size?: "big" | "small";
};

const EnergyLabel: React.FC<EnergyLabelProps> = ({energyClass, media, size = "big", className = ""}) => {
  const [open, setOpen] = useState(false);

  return (
    <span
      className={`energy-label-badge ${size}-badge EnergyLabel-module__wrapper ${styles[size]} ${className}`}
      onClick={(e) => {
        e.preventDefault();
        setOpen(true);
      }}
    >
      <span className={`energy-label-content icon icon-energylabel--${energyClass.toLowerCase()}--${size}`} />

      {!!media && (
        <Modal
          isVisible={open}
          closeFunction={() => {
            setOpen(false);
          }}
        >
          <div className={styles.imageWrapper}>
            <img alt={energyClass} src={media} />
          </div>
        </Modal>
      )}
    </span>
  );
};

export default EnergyLabel;
